<script setup lang="ts">
defineProps<{
  label?: string
  labelSize?: string
  path: string
  image: string
}>()
</script>

<template>
  <div class="bg-surface-yellow p-4 pt-8 rounded-lg" style="width: 248px;">
    <div class="w-full h-full relative flex flex-col items-center">
      <slot name="title">
        <h2 class="text-xl lg:text-lg !leading-tight text-center">
          Buy a Gift for<br>
          {{ label }}
        </h2>
      </slot>

      <div class="flex-1 flex flex-col justify-end w-full relative image-wrapper">
        <img
          :src="image"
          alt="generic giftly card"
          class="absolute inset-0 object-contain w-full h-full"
        >
      </div>

      <div class="w-full absolute bottom-0">
        <GButton
          variant="primary"
          name="buy-now"
          label="Buy Now"
          :href="path"
          rel="nofollow"
        />
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
.image-wrapper {
  aspect-ratio: 1 / 0.75;

  @media (min-width: 1024px) {
    aspect-ratio: 1 / 0.9;
  }
}
</style>
